<script>
import Buttons from "@/components/elements/Buttons";
import ModalAlert from "@/components/patterns/ModalAlert";

export default {
  name: "RegistrationCancellationModal",
  extends: ModalAlert,
  props: {
    title: {
      type: String,
      default: "Vuoi davvero cancellare la tua iscrizione?",
    },
    content: {
      type: String,
      default: "Se prosegui non potrai recuperare la tua iscrizione e perderai il posto a te riservato.",
    },
    code: {
      type: String,
      default: "",
    },
    container: {
      type: String,
      default: ".main-content",
    },
  },
  mounted() {
    const button1 = this.$createElement(
      Buttons,
      {
        attrs: {
          class: "dea-button dea-button--mid",
        },
        props: {
          icon: "close",
        },
        on: {
          click: this.hide,
        },
      },
      "Annulla"
    );
    const button2 = this.$createElement(
      Buttons,
      {
        attrs: {
          class: "dea-button dea-button--outline dea-button--mid",
        },
        props: {
          icon: "confirm",
        },
        on: {
          click: this.cancel,
        },
      },
      "Cancella iscrizione"
    );
    this.$slots.footer = [button1, button2];
  },
  methods: {
    cancel() {
      this.$emit("runRegistrationCancel");
    },
  },
};
</script>

<style lang="scss">
.dea-modal-info--activations {
  .dea-modal__footer {
    display: none;
  }
}
</style>
